import React from 'react';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import ReauthActions from './ReauthActions';
import { REAUTH_TEXT_KEYS } from './reauthTexts';

/**
 * Form of the reauthentication screen: it swallows the browser submit, only lets a valid form
 * through and carries the primary and leave buttons, so the password and the code steps share it.
 * @param {string} testId - Test id of the form.
 * @param {boolean} canSubmit - Whether the fields hold something that can be sent.
 * @param {boolean} isSubmitting - Whether a login is already in flight.
 * @param {function} onSubmit - Called with no arguments once the form is valid.
 * @param {function} onLeave - Called when the user leaves without signing in.
 * @param {string} submitTestId - Test id of the primary button.
 * @author armandoricosandoval -ai-
 */
const ReauthForm = ({ testId, canSubmit, isSubmitting, onSubmit, onLeave, submitTestId, children }) => {
  const { tempedgeTranslator: text } = useTempEdgeTranslator();

  const submitKey = isSubmitting ? REAUTH_TEXT_KEYS.submitting : REAUTH_TEXT_KEYS.signIn;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (canSubmit) onSubmit();
  };

  return (
    <form className="reauth-form" onSubmit={handleSubmit} data-testid={testId}>
      {children}
      <ReauthActions
        submitLabel={text(submitKey)}
        leaveLabel={text(REAUTH_TEXT_KEYS.leave)}
        canSubmit={canSubmit}
        submitTestId={submitTestId}
        onLeave={onLeave}
      />
    </form>
  );
};

export default ReauthForm;
